// 配置编译环境和线上环境之间的切换

const env = process.env;
const baseUrl = "";
// 图表库为avue和pig2套地址
const iconfontVersion = [
  "667895_v7uduh4zui", // 替换为iconfont最新的icon地址即可
  "1638883_g2ywtlub7ef", // 替换为iconfont最新的icon地址即可
  "2958183_m5ljsokfqjr", // 这个和后天渲染的icon无关，不知道哪里用了
];

// 图表库为avue和pig2套地址
const iconfontVersionNewList = [
  '4519732_66fol1ekj3t'
];

const iconfontUrl = "//at.alicdn.com/t/font_$key.css";
const iconfontUrlNewList = "//at.alicdn.com/t/c/font_$key.css";

const codeUrl = `${window.location.origin}/code`;
const actUrl = `${window.location.origin}/act/modeler.html?modelId=`;
if (env.NODE_ENV === "development") {
} else if (env.NODE_ENV === "production") {
} else if (env.NODE_ENV === "test") {
}
export { baseUrl, actUrl, iconfontUrl, iconfontVersion,iconfontVersionNewList,iconfontUrlNewList, codeUrl, env };
